import { Booking } from "./booking";

export enum OrderableType {
  Booking = "Booking",
  AddOn = "AddOn",
}

export enum SourceType {
  WL = "WL",
  FM = "FM",
  DS = "DS",
}

export interface Order {
  id: string;
  stripeClientSecret: string;
  totalPrice: number;
  confirmationID: string;
  status: OrderStatus;
  currencyCode: string | null;
  additionalNotes?: string;
  orderItems: OrderItem[];
  guestName: string;
  guestEmail: string;
  guestCompanyName: string;
  guestPhoneNumber: string;
  paymentMethodDetails: PaymentMethod | null;
  createdAt: Date;
}

export type AddOnType = "access_add_on";

export interface OrderItemBooking {
  orderableType: OrderableType.Booking;
  id: string;
  unitPrice: number;
  subTotal: number;
  details: Booking;
}

export interface CreditCard {
  last4: string;
  network: string;
  networkLogoUrl: string | null;
}

export interface PaymentMethod {
  card?: CreditCard;
}

export type OrderItem = OrderItemBooking;

export enum OrderStatus {
  Created = "created",
  Paid = "paid",
  Canceled = "canceled",
  Confirmed = "confirmed",
  Chargeback = "chargeback",
  Rejected = "rejected",
  DisputePending = "dispute_pending",
  DisputeWon = "dispute_won",
  DisputeLost = "dispute_lost",
}

export function getFirstBookingFromOrder(order: Order): Booking {
  return order.orderItems
    .filter((oi) => oi.orderableType === OrderableType.Booking)
    .map((oi) => {
      assertOrderItemBooking(oi);
      return oi.details;
    })[0];
}

export function getFirstOrderItemBookingFromOrder(
  order: Order
): OrderItemBooking {
  return order.orderItems.filter(
    (oi) => oi.orderableType === OrderableType.Booking
  )[0] as OrderItemBooking;
}

function assertOrderItemBooking(
  orderItem: OrderItem
): asserts orderItem is OrderItemBooking {
  if (orderItem.orderableType !== OrderableType.Booking) {
    throw new Error("Expected OrderItemBooking");
  }
}
